import React from 'react';
import { View } from '../../../View';
import { Text } from '../../../Text';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
import { Dots } from './Dots';
export const Awareness = ({ data }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container },
        React.createElement(Dots, null),
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.text }, data)));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        paddingVertical: size.C,
        paddingHorizontal: size.C * 2,
        alignItems: 'center'
    },
    text: {
        marginLeft: size.B,
        color: color.invert2.p56
    }
}));
//# sourceMappingURL=index.js.map